import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { useCognitoSaml } from '../../hooks/useCognitoSaml';

const MyriamIDPForm: FC = () => {
  const { t } = useTranslate();
  const { loginWithMYRIAM, loading, error } = useCognitoSaml();

  if (loading) {
    return (
      <div className="auth-form mt-4">
        <div className="text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">{t('Loading')}</span>
          </div>
          <p className="mt-2">{t('RedirectingToLogin')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        <strong>{t('Error')}:</strong> {error}
        <button type="button" className="btn btn-link" onClick={loginWithMYRIAM}>
          {t('TryAgain')}
        </button>
      </div>
    );
  }

  return (
    <div className="auth-form mt-4">
      <div className="form-group">
        <button
          type="button"
          className="btn btn-lg btn-secondary btn-block btn-login-myriam-idp"
          onClick={loginWithMYRIAM}
          disabled={loading}
        >
          <em className="icon ni ni-send ni-lock" />
          <span>{t('LoginWithMyriamIdp')}</span>
        </button>
      </div>
    </div>
  );
};

export default MyriamIDPForm;
